import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSliderTabInactive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 3,
	viewBox: "0 0 21 3",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.82617 1.5H19.0436",
		stroke: "white",
		strokeWidth: 3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSliderTabInactive;
